import { format } from "date-fns";

export default (date: Date, formatString = "eeee, dd MMMM") => {
    return format(new Date(date), formatString);
};
